import { useCallback, useState } from 'react';
import memoizeOne from 'react-utils/memoizeOne';
import CALENDAR_VIEW_TYPES from '../constants/CalendarViewTypes';
import { getSnapIntervalHeight } from '../constants/dragDrop';
import { getClosestSnapPoint, getEventDurationInHours, getEventHeight } from '../lib/dragDrop';
import { useTheme, remCalc } from '../lib/styles';
const getContainerMargin = hourHeight => hourHeight / 2;
const getOffset = memoizeOne((closestSnapPoint, hourHeight) => {
  return closestSnapPoint * getSnapIntervalHeight(hourHeight) + getContainerMargin(hourHeight);
});
export default function useSetHoverMarkerStyle({
  containerRef,
  viewType
}) {
  const {
    uiAddonCalendars: {
      dayView: {
        hourHeight
      },
      util: {
        raw
      }
    }
  } = useTheme();
  const [height, setHeight] = useState();
  const [top, setTop] = useState();
  const rawHourHeight = raw(hourHeight);
  const setHoverMarkerStyle = useCallback((__props, monitor) => {
    if (viewType !== CALENDAR_VIEW_TYPES.MONTH) {
      const item = monitor.getItem();
      const {
        start,
        end
      } = item._internal ? item._internal : item;
      const eventHeight = getEventHeight(start, end, rawHourHeight);
      setHeight(remCalc(eventHeight));
      const eventDurationInHours = getEventDurationInHours(start, end);
      const closestSnapPoint = getClosestSnapPoint({
        containerRef,
        monitor,
        eventDurationInHours,
        hourHeight: rawHourHeight
      });
      setTop(getOffset(closestSnapPoint, rawHourHeight));
    }
  }, [containerRef, rawHourHeight, viewType]);
  return [{
    height,
    top
  }, setHoverMarkerStyle];
}